import { Link, useLocation } from 'react-router-dom';
import { AuthShell } from './SignInPage';

export function VerifyEmailPage() {
  const location = useLocation();
  const email = (location.state as { email?: string } | null)?.email;
  return (
    <AuthShell>
      <h1 className="text-2xl font-semibold tracking-tight">Check your inbox</h1>
      <p className="text-muted-foreground mt-2 text-sm leading-relaxed">
        We sent a verification link
        {email ? (
          <>
            {' '}
            to <strong className="text-foreground">{email}</strong>
          </>
        ) : null}
        . Click it to activate your account — the link expires in 24 hours.
      </p>
      <p className="text-muted-foreground mt-6 text-sm">
        Didn't get it? Check your spam folder, or{' '}
        <Link to="/sign-up" className="text-primary hover:underline">
          try again
        </Link>
        .
      </p>
    </AuthShell>
  );
}
